export default "__VITE_ASSET__aa6b9d4b__"